import React, { useEffect } from "react";
import CourseTypes from "../components/Sections/CourseTypes";

const CourseDetails = ({ courses, loading }) => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <div>
      <CourseTypes courses={courses} loading={loading} />
    </div>
  );
};

export default CourseDetails;
